import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { env } from "@/lib/config/env";

export const VerifyEmailSentPage = () => {
  const expiryHours = env.emailVerificationExpiryHours;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-md space-y-8">
          <Card className="shadow-medium">
            <CardHeader className="text-center pb-4">
              <div className="mx-auto mb-4 rounded-full bg-primary/10 p-4 w-fit">
                <Mail className="h-8 w-8 text-primary" />
              </div>
              <CardTitle className="text-xl">Check your email</CardTitle>
              <CardDescription className="mt-2">
                We've sent you a verification link. Please check your inbox and click the
                link to verify your email address.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="p-4 bg-muted/50 rounded-lg border border-border">
                <p className="text-sm text-muted-foreground text-center">
                  The verification link will expire after{" "}
                  <span className="font-medium text-foreground">
                    {expiryHours} {expiryHours === 1 ? "hour" : "hours"}
                  </span>
                </p>
              </div>
              <Link to="/login">
                <Button variant="outline" className="w-full gap-2">
                  <ArrowLeft className="h-4 w-4" />
                  Back to Sign In
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>

      <footer className="py-6 text-center">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} My Professional Tax. All rights reserved.
        </p>
      </footer>
    </div>
  );
};
